
import { useState, useEffect } from "react";
import { Profile } from "@/hooks/profile/types";

interface UseCompleteProfileFormProps {
  profile: Profile;
}

export const useCompleteProfileForm = ({ profile }: UseCompleteProfileFormProps) => {
  const [firstName, setFirstName] = useState(profile.first_name || "");
  const [lastName, setLastName] = useState(profile.last_name || "");
  const [birthdate, setBirthdate] = useState(profile.birthdate || "");
  const [phone, setPhone] = useState(profile.phone || "");
  const [address, setAddress] = useState(profile.address || "");
  const [emergencyPhone, setEmergencyPhone] = useState(profile.emergency_phone || "");
  const [healthInsurance, setHealthInsurance] = useState(profile.health_insurance || "");
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (profile) {
      setFirstName(profile.first_name || "");
      setLastName(profile.last_name || "");
      setBirthdate(profile.birthdate || "");
      setPhone(profile.phone || "");
      setAddress(profile.address || "");
      setEmergencyPhone(profile.emergency_phone || "");
      setHealthInsurance(profile.health_insurance || "");
    }
  }, [profile]);

  const isComplete = firstName.trim().length > 0 && lastName.trim().length > 0 && birthdate.trim().length > 0;

  return {
    firstName, setFirstName,
    lastName, setLastName,
    birthdate, setBirthdate,
    phone, setPhone,
    address, setAddress,
    emergencyPhone, setEmergencyPhone,
    healthInsurance, setHealthInsurance,
    isSubmitting, setIsSubmitting,
    isComplete
  };
};
